import { render, staticRenderFns } from "./SlideShow.vue?vue&type=template&id=2b072c5a&scoped=true"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"
import style0 from "./SlideShow.vue?vue&type=style&index=0&id=2b072c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b072c5a",
  null
  
)

export default component.exports